export const AiChatBubble = {
  flow: 'y',
  gap: 'Y',
  padding: 'A',
  round: 'Z',
  maxWidth: '85%',
  background: (el, s) => s.role === 'assistant' ? 'inkSurface' : 'inkMid',
  borderLeft: (el, s) => s.role === 'assistant' ? '2px solid purple' : 'none',
  border: (el, s) => s.role === 'user' ? '1px solid inkBorder' : 'none',
  alignSelf: (el, s) => s.role === 'user' ? 'flex-end' : 'flex-start',
  RoleLabel: {
    text: (el, s) => s.role === 'assistant' ? '\u2726 AI Assistant' : 'You',
    fontSize: 'Y',
    fontWeight: '600',
    color: (el, s) => s.role === 'assistant' ? 'purple' : 'inkMuted'
  },
  MessageText: {
    text: (el, s) => s.content,
    fontSize: 'Z',
    color: (el, s) => s.role === 'assistant' ? 'inkText' : 'inkSubtle',
    lineHeight: '1.6',
    whiteSpace: 'pre-wrap'
  }
}
